/**
 * Safely format a number to currency with 2 decimal places
 * @param value - The value to format (can be number, string, null, or undefined)
 * @param currency - The currency symbol (default: 'RM')
 * @returns Formatted currency string
 */
export const formatCurrency = (value: any, currency: string = 'RM'): string => {
  if (value === null || value === undefined || value === '') {
    return `${currency} 0.00`;
  }
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return `${currency} 0.00`;
  }
  
  return `${currency} ${numValue.toFixed(2)}`;
};

/**
 * Safely format a number to 2 decimal places
 * @param value - The value to format (can be number, string, null, or undefined)
 * @returns Formatted number string
 */
export const formatNumber = (value: any): string => {
  if (value === null || value === undefined || value === '') {
    return '0.00';
  }
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return '0.00';
  }
  
  return numValue.toFixed(2);
};

